<div class="order-edit-detail-container" id="materials">
  <app-order-edit-material
    *ngIf="editMaterial"
    [saving]="panelStatus?.busy"
    [definitions]="definitions"
    [material]="editMaterial"
    [materialTypes]="materialTypes"
    [panelStatus]="panelStatusMaterial"
    (nextClicked)="nextClickedFn()"
    (saveMaterialClicked)="saveMaterialClickedFn($event)"
  >
  </app-order-edit-material>

  <!-- only show if there are ordered materials -->
  <app-order-material-lines
    [materials]="isCcr() ? florderDetail.ccr.ccrLineItems : florderDetail.materials"
    [definitions]="definitions"
    [panelStatus]="panelStatusMaterial"
    [readonly]="!panelStatus?.isEdit"
    [palletQuantity]="florderDetail.palletQuantity"
    [loadedEpp]="loadedEpp"
    [maxEpp]="maxEpp"
    [fullTruck]="florderDetail.fullTruck"
    (editMaterialClicked)="editMaterialClicked($event)"
    (removeMaterialClicked)="removeMaterialClicked.emit($event)"
  >
  </app-order-material-lines>

  <div class="form-container" *ngIf="panelStatus?.isEdit">
    <div class="hr"></div>
    <div class="buttons save-button" *ngIf="panelStatus?.isEdit">
      <div class="hr-thick"></div>
      <eps-button
        type="link"
        *ngIf="panelStatus.isNew"
        (buttonClick)="cancelClicked.emit()"
        label="SHARED.BUTTONS.CANCEL"
      ></eps-button>
      <eps-button
        [disabled]="!isValid() || panelStatus?.saving"
        (buttonClick)="nextClickedFn()"
        [label]="panelStatus.isNew ? 'ORDERS.DETAIL.BUTTONS.NEXT' : 'ORDERS.DETAIL.BUTTONS.SAVE'"
        [submit]="isValid() && !panelStatus?.saving && (nextOnEnterPressed$ | async)"
      ></eps-button>
    </div>
  </div>
</div>
